import { format, isBefore, parse } from "date-fns";
import { IClassDetails } from "repoV2/features/CheckoutPages/utils/apis/SessionDetailsApi/SessionDetailsApi.interface";
import {
    DATE_SHORT_FORMAT,
    render_day_order,
    SHORT_DAY_TIME_FORMAT,
} from "repoV2/features/Common/modules/DateTime/modules/Time/Time.constants";

export const getClassesRenderData = ({
    classItem,
}: {
    classItem: IClassDetails;
}) => {
    const scheduleType = classItem?.schedult_type || "";

    // For rendering, we change, "Weekly" to render as "Weekly"
    // Not using CSS, as there will be more string further which may get affected as well
    const renderSchedultType =
        scheduleType.charAt(0).toUpperCase() +
        scheduleType.slice(1).toLowerCase();

    const startingDate = new Date(classItem.starting_date);
    const renderStartingDate = format(startingDate, DATE_SHORT_FORMAT);

    const sortedSlots = classItem.timings_list.sort((a, b) => {
        const dayDiff =
            render_day_order.indexOf(a.day) - render_day_order.indexOf(b.day);
        if (dayDiff !== 0) {
            return dayDiff; // Sort by day first
        }

        // Create date objects for comparison
        const timeA = parse(
            `${a.day} ${a.time}`,
            SHORT_DAY_TIME_FORMAT,
            new Date()
        );
        const timeB = parse(
            `${b.day} ${b.time}`,
            SHORT_DAY_TIME_FORMAT,
            new Date()
        );

        return isBefore(timeA, timeB) ? -1 : 1;
    });

    const slotsLabelArray = sortedSlots.map(
        item => `${item.day.substring(0, 3)} ${item.time}`
    );
    const slotsLabel = slotsLabelArray.join(" | ");

    const groupedSlots: Array<{ day: string; time: string[] }> = [];
    sortedSlots.forEach(({ day, time }) => {
        // Find if the day already exists in groupedSlots
        const existingDay = groupedSlots.find(slot => slot.day === day);

        if (existingDay) {
            // If the day exists, push the time into the array
            existingDay.time.push(time);
        } else {
            // If not, create a new entry for this day
            groupedSlots.push({ day, time: [time] });
        }
    });

    return {
        renderSchedultType,
        renderStartingDate,
        sortedSlots,
        slotsLabel,
        groupedSlots,
    };
};
